module.exports = __webpack_public_path__ + "static/img/1.59f0aff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/zh/1.png
// module id = ViHq
// module chunks = 0